/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaginatedPolicyConfFileListDto } from '../../models/backend-paginated-policy-conf-file-list-dto';

export interface AccountPolicyConfList$Params {
  /**
   * Number of results to return per page.
   */
  limit?: number;

  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export function accountPolicyConfList(
  http: HttpClient,
  rootUrl: string,
  params?: AccountPolicyConfList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaginatedPolicyConfFileListDto>> {
  const rb = new RequestBuilder(rootUrl, accountPolicyConfList.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaginatedPolicyConfFileListDto>;
    }),
  );
}

accountPolicyConfList.PATH = '/api/account/policy_conf/';
